import LogoG20 from './LogoG20';

export default LogoG20;
